module.exports = __webpack_public_path__ + "img/banner22.db1c4ddb.png";